import React from "react";
import FadedRightImage from "../common/FadedRightImage";
import TopFadedFAQImageSvg from "../../Icons/TopFadedFAQImageSvg";

export default function TopFadedFAQImage() {
  return (
    <FadedRightImage
      title="Help centre"
      description="Here are some of the most frequently asked questions for more information."
      image= {<div className="mt-5"><TopFadedFAQImageSvg/></div>}
    />
  );
}
